export enum MediaStreamId {
  Video = 1,
  Audio = 3,
}

export enum MediaStreamType {
  Video = "video",
  Audio = "audio",
}

export const MediaStreamLabel: { [key in MediaStreamId]: MediaStreamType } = {
  [MediaStreamId.Video]: MediaStreamType.Video,
  [MediaStreamId.Audio]: MediaStreamType.Audio,
};

export enum LoadingPercentageRanges {
  CONNECTING_TO_SERVER = 25,
  REGISTERING_WITH_SERVER = 50,
  REGISTERED_WITH_SERVER = 75,
  ALMOST_THERE = 95,
  CONNECTED = 100,
}

export enum GameLaunchStatus {
  STATUS_STARTING = "STATUS_STARTING",
  STATUS_GAMERUNNING_DISCONNECTED = "STATUS_GAMERUNNING_DISCONNECTED",
  STATUS_LAUNCHING_DISCONNECTED = "STATUS_LAUNCHING_DISCONNECTED",
  STATUS_INSTALLING = "STATUS_INSTALLING",
  STATUS_LAUNCHER_UP = "STATUS_LAUNCHER_UP",
  STATUS_STEAMLOGIN = "STATUS_STEAMLOGIN",
  STATUS_LAUNCHING = "STATUS_LAUNCHING",
  STATUS_STEAMLOGIN_SUCCESS = "STATUS_STEAMLOGIN_SUCCESS",
  STATUS_STEAMLOGIN_COMPLETE = "STATUS_STEAMLOGIN_COMPLETE",
  STATUS_SETLAUNCHEROPTIONS = "STATUS_SETLAUNCHEROPTIONS",
  STATUS_EULA = "STATUS_EULA",
  STATUS_NOGAMELICENSE = "STATUS_NOGAMELICENSE",
  STATUS_CONSENTNOCLOUDSYNC = "STATUS_CONSENTNOCLOUDSYNC",
  STATUS_GAMERUNNING_UPDATEPENDING = "STATUS_GAMERUNNING_UPDATEPENDING",
  STATUS_UPDATEDETECTED = "STATUS_UPDATEDETECTED",
  STATUS_GAMELAUNCH_TIMEOUT = "STATUS_GAMELAUNCH_TIMEOUT",
  STATUS_GAMELAUNCHING = "STATUS_GAMELAUNCHING",
  STATUS_GAMERUNNING = "STATUS_GAMERUNNING",
  STATUS_GAMEEXITED = "STATUS_GAMEEXITED",
  STATUS_SYNCONEXIT = "STATUS_SYNCONEXIT",
  STATUS_INACTIVITY_TIMEOUT = "STATUS_INACTIVITY_TIMEOUT",
  ERROR = "error",
  NETWORK_ERROR = "network_error",
  NETWORK_DISCONNECTED = "network_disconnected",
  REMOTE_INPUT_REQUIRED = "remote_input_required",
  ERR_NOTACTIVE = "ERR_NOTACTIVE",
  NONE = "",
}

export enum SignalingStatus {
  DISCONNECTED = "disconnected",
  CONNECTING = "connecting",
  CONNECTED = "connected",
}

export const EON_VIDEO_ID = "eon-video";
export const EON_AUDIO_ID = "eon-audio";
export const EON_KEYBOARD_INPUT_ID = "keyboard-input";
